const rxEmailAddress = new RegExp("^[A-Z0-9._%+-]+@[A-Z0-9.-]+\\.[A-Z]{2,}$", "i");
const rxMuellerEmailAddress = new RegExp("^[A-Z0-9._%+-]+@muellerreports.com", "i");
const rxSemiColonSeparatedEmailAddresses = new RegExp("^(([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9_\\-\\.]+)\.([a-zA-Z]{2,5}){1,25}(($)|( *;+ *$)|( *;+ *(?=[a-zA-Z0-9_\\-\\.]))))*$", "i");
const rxPhoneNumber = new RegExp(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/);
const rxZipcode = new RegExp("^[0-9]{5}$");

export {
  rxEmailAddress,
  rxMuellerEmailAddress,
  rxSemiColonSeparatedEmailAddresses,
  rxPhoneNumber,
  rxZipcode,
};